export default __webpack_public_path__ + "static/media/Mark-4-Suit-Cycles-12.2c0fe0aa.jpg";